import { createAction } from '@reduxjs/toolkit';

export const SET_INITIAL_PATH = 'SET_INITIAL_PATH';

export const setInitialPath = createAction(
    SET_INITIAL_PATH,
    (path: string) => ({ payload: path }),
);
